import Proto from 'generated/freeform_v2_pb';
import { Mat2d, Vec2, mat2d, vec2 } from 'utility/gl-matrix';

export function mat2dToProtoAffineTransform(mat: Mat2d, out: Proto.AffineTransform = new Proto.AffineTransform()): Proto.AffineTransform {
  out.setA(mat2d.a(mat));
  out.setB(mat2d.b(mat));
  out.setC(mat2d.c(mat));
  out.setD(mat2d.d(mat));
  out.setTx(mat2d.tx(mat));
  out.setTy(mat2d.ty(mat));
  return out;
}

export function protoAffineTransformToMat2d(xf: Proto.AffineTransform, out: Mat2d): Mat2d {
  mat2d.set(
    out,
    xf.getA(),
    xf.getB(),
    xf.getC(),
    xf.getD(),
    xf.getTx(),
    xf.getTy(),
  );
  return out;
}

export const sizeToVec2 = (size: Proto.Size): Vec2 => vec2.fromValues(size.getWidth(), size.getHeight());

export const dateToTimestamp = (date: Date): any =>{
    if (window.proto) {
        const proto = window.proto;
        const timeMS = date.getTime();
        const timestamp = new (proto as any).google.protobuf.Timestamp()
        timestamp.setSeconds(timeMS / 1000);
        timestamp.setNanos((timeMS % 1000) * 1e6);
        return timestamp;
    }
}
